/* Barra de acumulo para frete gratis — atualizacao sem recarregar a pagina.

   Na pagina de produto a barra e a unica coisa que precisa saber do carrinho
   depois do "adicionar": o resto da tela nao muda. Entao em vez de registrar
   mais uma secao no getSectionsToRender do drawer (o que obrigaria a mexer em
   cart-drawer.js e cart.js), a barra so escuta o evento que o proprio tema ja
   publica quando o carrinho muda.

   No drawer a barra tambem existe, mas la ela nem depende deste arquivo: o
   .drawer__inner inteiro e reconstruido pelo Liquid a cada mudanca. Este
   script atualiza as duas do mesmo jeito, e o custo disso e zero. */

(function () {
  if (customElements.get('vorcaro-frete-gratis')) return;

  /* O Liquid formata o valor inicial com o filtro money. Para o numero que
     aparece depois nao sair diferente do que veio do servidor, aqui repetimos
     o formato de moeda da loja (shop.money_format) em vez de usar o Intl: o
     Intl acerta o pt-BR, mas erraria qualquer loja com formato customizado. */
  var REGRAS = {
    amount: [2, ',', '.'],
    amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','],
    amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_space_separator: [2, ' ', ','],
    amount_no_decimals_with_space_separator: [0, ' ', ','],
    amount_with_apostrophe_separator: [2, "'", '.'],
  };

  function formatarDinheiro(centavos, formato) {
    var achado = formato.match(/\{\{\s*(\w+)\s*\}\}/);
    var regra = REGRAS[achado && achado[1]] || REGRAS.amount;
    var casas = regra[0];
    var milhar = regra[1];
    var decimal = regra[2];

    var partes = (Math.abs(centavos) / 100).toFixed(casas).split('.');
    var inteiro = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, milhar);
    var valor = partes[1] ? inteiro + decimal + partes[1] : inteiro;

    return formato.replace(/\{\{\s*\w+\s*\}\}/, valor);
  }

  customElements.define(
    'vorcaro-frete-gratis',
    class VorcaroFreteGratis extends HTMLElement {
      connectedCallback() {
        this.meta = parseInt(this.dataset.meta, 10);
        if (!this.meta || this.meta <= 0) return;

        this.frase = this.querySelector('[data-v-frete-frase]');
        this.trilho = this.querySelector('[data-v-frete-trilho]');
        this.preenchimento = this.querySelector('[data-v-frete-preenchimento]');

        if (typeof subscribe === 'function') {
          this.desinscrever = subscribe(PUB_SUB_EVENTS.cartUpdate, this.aoMudarCarrinho.bind(this));
        }
      }

      disconnectedCallback() {
        if (this.desinscrever) this.desinscrever();
      }

      /* O evento chega de dois lugares com formatos diferentes: o cart-items
         manda a resposta do /cart/change.js, que ja traz o total; o
         product-form manda a resposta do /cart/add.js, que descreve so a linha
         adicionada. Quando o total nao vem junto, buscamos o carrinho. */
      aoMudarCarrinho(evento) {
        var total = evento && evento.cartData && evento.cartData.total_price;

        if (typeof total === 'number') {
          this.pintar(total);
          return;
        }

        fetch(window.routes.cart_url + '.js')
          .then(function (resposta) {
            return resposta.json();
          })
          .then(
            function (carrinho) {
              this.pintar(carrinho.total_price);
            }.bind(this)
          )
          .catch(function () {
            /* Sem rede a barra fica no ultimo numero conhecido, que e melhor do
               que zerar ou sumir no meio da compra. */
          });
      }

      pintar(total) {
        var falta = this.meta - total;
        var pct = Math.min(100, Math.round((total / this.meta) * 1000) / 10);
        var atingido = falta <= 0;

        this.frase.textContent = atingido
          ? this.dataset.textoOk
          : this.dataset.textoFalta.replace('[valor]', formatarDinheiro(falta, this.dataset.formato));

        this.preenchimento.style.width = pct + '%';
        this.trilho.setAttribute('aria-valuenow', Math.round(pct));

        /* A classe so entra na virada: se ela fosse reescrita a cada evento, o
           brilho de "meta batida" tocaria de novo a cada item adicionado. */
        if (atingido !== this.classList.contains('v-frete--ok')) {
          this.classList.toggle('v-frete--ok', atingido);
        }
      }
    }
  );
})();
